import { css } from '@emotion/css';

export const colorPickerItemHoverStyles = (color: string) => css`
  :hover {
    background-color: ${color};
  }
`;
